<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { Txt, type TxtVariant } from '../../Txt';

	let {
		variant = 'label2',
		tabs,
		setActiveTab,
		activeTab,
		dataCy,
		showIndex = false,
		classes = {},
		...rest
	}: Props = $props();

	interface Props {
		showIndex?: boolean;
		variant?: TxtVariant;
		tabs: { id: string; title: string; disabled?: boolean }[];
		setActiveTab: (index: number) => void;
		activeTab: number;
		dataCy: string;
		class?: string;
		classes?: {
			currentTabBorder?: string;
			index?: string;
			button?: string;
			tabLabel?: string;
			inactiveTabLabel?: string;
			disabledTabLabel?: string;
		};
	}

	let dataCyPrefix = $derived(`${dataCy}-headers`);
</script>

<div class={twMerge('no-scrollbar flex overflow-x-scroll pr-4', rest.class)}>
	{#each tabs as tab, index (tab.id)}
		<button
			type="button"
			class={twMerge(
				classNames(
					'border-b border-gray-200 pt-4 text-gray-500 hover:text-gray-800 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900',
					{
						'pl-4': index,
						'flex items-center pb-4': showIndex
					}
				),
				tab.disabled && 'cursor-not-allowed',
				classes?.button
			)}
			disabled={tab.disabled}
			onclick={() => setActiveTab(index)}
			data-cy={`${dataCyPrefix}-${index}`}
		>
			{#if showIndex}
				<Txt {variant} class={classes?.index}>
					{index + 1}
				</Txt>
			{/if}

			<Txt
				{variant}
				class={twMerge(
					classNames(
						'mb-4 whitespace-nowrap',
						{ 'mb-0': showIndex },
						classes.tabLabel,
						index !== activeTab ? classes.inactiveTabLabel : ''
					),
					tab.disabled && (classes.disabledTabLabel || 'text-gray-300')
				)}
			>
				{tab.title}
			</Txt>
			<!--
				twMerge so `currentTabBorder` can override the size/offset below —
				with plain concatenation an override would tie with the base classes
				and fall back to CSS source order.
			-->
			<span
				class={twMerge(
					classNames('block h-[1px] w-full translate-y-[1px]', {
						'bg-gray-900': index === activeTab
					}),
					classes?.currentTabBorder
				)}
			></span>
		</button>
	{/each}
</div>
